(function ($) {
    if ($('section.testimonials-slider').length) {
        var swiper = new Swiper('.testimonials-slider .swiper', {
            autoHeight: true,
            observer: true,
            observeParents: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
            },
            navigation: {
                nextEl: '.testimonials-slider .swiper-button-next',
                prevEl: '.testimonials-slider .swiper-button-prev',
            },
            // allowTouchMove: false,
        });
    }
})(jQuery);